import { isDate, format, parseISO } from 'date-fns';
import { validateEmail } from "../config/utils";

const validator = require('validator');
const brnv = require('bank-routing-number-validator');
const creditCardType = require('credit-card-type');

export const validateCardData = (paymentFields, court) => {
    let errors = '';
    const cardTypeVal = creditCardType(paymentFields.cardNumber);
    const cardType = Array.isArray(cardTypeVal) && cardTypeVal.length > 0 ? cardTypeVal[0] : '';
    if (!paymentFields.cardNumber) {
        errors = 'The card number is required';
    } else if (!validator.isCreditCard(paymentFields.cardNumber)) {
        errors = 'The card number is invalid';
    } else {
        if (!cardType || (cardType && cardType.type !== 'visa' && cardType.type !== 'mastercard' &&
            cardType.type !== 'discover' && cardType.type !== 'american-express')) {
            if (cardType && cardType.niceType) {
                errors = `${cardType.niceType} cards are not accepted at CitePay`;
            } else {
                errors = 'Your card is not one of the types accepted at CitePay'
            }
        }
    }
    if (!paymentFields.expDate || !isDate(paymentFields.expDate)) {
        if (errors.length > 2) errors += '; ';
        errors += 'Card expiration date is invalid';
    }
    if (!paymentFields.cvv2 || (cardType.type === 'american-express' ? paymentFields.cvv2.length !== 4 : paymentFields.cvv2.length !== 3)) {
        if (errors.length > 2) errors += '; ';
        errors += 'CVC is invalid';
    }
    if (cardType.type === 'american-express' && !court.allowAmex) {
        if (errors.length > 2) errors += '; ';
        errors += `The ${court.courtName} does not accept American Express`;
    }
    if (paymentFields.email && !validateEmail(paymentFields.email)) {
        if (errors.length > 2) errors += '; ';
        errors += `The email address is invalid`;
    }
    if (court.requireContactInfo && !paymentFields.email && !paymentFields.phone) {
        if (errors.length > 2) errors += '; ';
        errors += `${court.courtName} requires that you enter either an email address or a phone number`;
    }
    return errors;
}

export const validateCheckData = (paymentFields, court) => {
    let errors = '';
    if (!brnv.ABARoutingNumberIsValid(paymentFields.routingNumber)) {
        errors = 'Routing number is invalid';
    }
    if (! paymentFields.bankAccountNumber || paymentFields.bankAccountNumber.length < 4) {
        if (errors.length > 2) errors += '; ';
        errors += 'Bank account number is invalid';
    }
    if (paymentFields.email && !validateEmail(paymentFields.email)) {
        if (errors.length > 2) errors += '; ';
        errors += `The email address is invalid`;
    }
    if (court.requireContactInfo && !paymentFields.email && !paymentFields.phone) {
        if (errors.length > 2) errors += '; ';
        errors += `${court.courtName} requires that you enter either an email address or a phone number`;
    }
    return errors;
}

export const validatePosData = (paymentFields) => {
    let errors = '';
    if (!paymentFields.laneId || paymentFields.laneId === '0') {
        errors += 'You must select your card terminal';
    }
    return errors;
}

export const validateZeroAmount = (paymentRequest) => {
    let errors = '';
    let totalAmount = parseFloat(paymentRequest.totalAmount);
    if (totalAmount <= 0) {
        errors = 'The payment amount must be greater than zero';
    }
    return errors;
}

export const validateContactInfoAndZeroCheck = (paymentRequest, court) => {
    let errors = '';
    let totalAmount = paymentRequest.totalAmount;
    if (totalAmount <= 0) {
        errors += 'The payment amount must be greater than zero';
    }
    if (court.requireContactInfo && !paymentRequest.email && !paymentRequest.phone) {
        if (errors) errors += '; ';
        errors += 'Either an email address or a phone number is required';
    }
    return errors;
}

export const getDisplayTime = (timeIn) => {
    if (timeIn) {
        return format(parseISO(timeIn), 'MM/dd/yyyy hh:mm:ss aa')
    }
}

export const getReceiptRequest = (paymentRequest, paymentResponse) => {
    const request = {
        courtId: paymentRequest.courtId,
        transactionId: paymentResponse.transactionId,
        unpaidBalances: paymentRequest.unpaidBalances ? paymentRequest.unpaidBalances : null
    }
    return JSON.stringify(request);
}
